/**
 * FontAwesome Icon Configuration
 *
 * This file registers icons that are referenced by string name throughout the app.
 * Icons directly imported in components don't need to be registered here.
 */
import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faAngleDoubleDown,
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faAngleDoubleUp,
    faArchive,
    faArrowCircleLeft,
    faArrowCircleRight,
    faArrowDown,
    faArrowLeft,
    faArrowUp,
    faArrowsAlt,
    faArrowsAltH,
    faBan,
    faBars,
    faBell,
    faBook,
    faBroom,
    faCalendarCheck,
    faCaretDown,
    faCaretRight,
    faCertificate,
    faChartLine,
    faCheck,
    faCheckCircle,
    faChevronCircleDown,
    faChevronCircleUp,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faClock,
    faClockRotateLeft,
    faCodeBranch,
    faCog,
    faComment,
    faCompress,
    faCopy,
    faDatabase,
    faDolly,
    faDownLeftAndUpRightToCenter,
    faEdit,
    faEllipsisH,
    faEllipsisV,
    faEnvelope,
    faExclamation,
    faExclamationCircle,
    faExclamationTriangle,
    faExchangeAlt,
    faExternalLinkAlt,
    faExternalLinkSquareAlt,
    faEye,
    faFileAlt,
    faFileExcel,
    faFilePdf,
    faFill,
    faFilter,
    faGasPump,
    faGripHorizontal,
    faHandPointer,
    faHourglass,
    faInfo,
    faInfoCircle,
    faList,
    faListOl,
    faMinus,
    faMinusCircle,
    faMinusSquare,
    faNotEqual,
    faPen,
    faPencilAlt,
    faPenSquare,
    faPlus,
    faPrint,
    faProjectDiagram,
    faQuestionCircle,
    faRefresh,
    faRotateLeft,
    faRotateRight,
    faScaleUnbalancedFlip,
    faSearch,
    faSearchPlus,
    faShareFromSquare,
    faShip,
    faSignInAlt,
    faSignOutAlt,
    faSlidersH,
    faSort,
    faSortAmountDown,
    faSortAmountDownAlt,
    faSortAmountUp,
    faSortDown,
    faSortUp,
    faStar,
    faStarOfLife,
    faSyncAlt,
    faTable,
    faTemperatureHigh,
    faTh,
    faThumbtack,
    faTimes,
    faTimesCircle,
    faTrash,
    faUndo,
    faUpDownLeftRight,
    faUpload,
    faUser,
    faUserCircle,
    faWater,
    faWeightHanging,
    faWifi,
    faWindowClose,
    faWindowMinimize,
    faLock,
    faUnlock,
} from '@fortawesome/free-solid-svg-icons';

// Register all icons that were previously in App.tsx
// This ensures all string-based icon references throughout the app work correctly
library.add(
    faAngleDoubleDown,
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faAngleDoubleUp,
    faArchive,
    faArrowCircleLeft,
    faArrowCircleRight,
    faArrowDown,
    faArrowLeft,
    faArrowUp,
    faArrowsAlt,
    faArrowsAltH,
    faBan,
    faBars,
    faBell,
    faBook,
    faBroom,
    faCalendarCheck,
    faCaretDown,
    faCaretRight,
    faCertificate,
    faChartLine,
    faCheck,
    faCheckCircle,
    faChevronCircleDown,
    faChevronCircleUp,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faClock,
    faClockRotateLeft,
    faCodeBranch,
    faCog,
    faComment,
    faCompress,
    faCopy,
    faDatabase,
    faDolly,
    faDownLeftAndUpRightToCenter,
    faEdit,
    faEllipsisH,
    faEllipsisV,
    faEnvelope,
    faExclamation,
    faExclamationCircle,
    faExclamationTriangle,
    faExchangeAlt,
    faExternalLinkAlt,
    faExternalLinkSquareAlt,
    faEye,
    faFileAlt,
    faFileExcel,
    faFilePdf,
    faFill,
    faFilter,
    faGasPump,
    faGripHorizontal,
    faHandPointer,
    faHourglass,
    faInfo,
    faInfoCircle,
    faList,
    faListOl,
    faMinus,
    faMinusCircle,
    faMinusSquare,
    faNotEqual,
    faPen,
    faPencilAlt,
    faPenSquare,
    faPlus,
    faPrint,
    faProjectDiagram,
    faQuestionCircle,
    faRefresh,
    faRotateLeft,
    faRotateRight,
    faScaleUnbalancedFlip,
    faSearch,
    faSearchPlus,
    faShareFromSquare,
    faShip,
    faSignInAlt,
    faSignOutAlt,
    faSlidersH,
    faSort,
    faSortAmountDown,
    faSortAmountDownAlt,
    faSortAmountUp,
    faSortDown,
    faSortUp,
    faStar,
    faStarOfLife,
    faSyncAlt,
    faTable,
    faTemperatureHigh,
    faTh,
    faThumbtack,
    faTimes,
    faTimesCircle,
    faTrash,
    faUndo,
    faUpDownLeftRight,
    faUpload,
    faUser,
    faUserCircle,
    faWater,
    faWeightHanging,
    faWifi,
    faWindowClose,
    faWindowMinimize,
    faLock,
    faUnlock
);
